import { render, staticRenderFns } from "./CosMainBanner.vue?vue&type=template&id=2f63eedf&scoped=true&"
import script from "./CosMainBanner.vue?vue&type=script&lang=ts&"
export * from "./CosMainBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CosMainBanner.vue?vue&type=style&index=0&id=2f63eedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63eedf",
  null
  
)

export default component.exports